import React from 'react';
import {Swiper} from '../swiper';
import {View, LayoutChangeEvent} from 'react-native';
import {NewsCard} from '../newsCard';
import {Props} from './model';
import {useStyles} from '../../hooks/styles';
import {LoadableContent} from '../loadableContent';

export default ({news}: Props) => {
  const [slidesPerView, setSlidesPerView] = React.useState(1);

  const styles = useStyles(() => ({
    container: {
      marginBottom: 24,
    },
    newsCardContainer: {
      flexGrow: 1,
      paddingHorizontal: 20,
    },
    newsCard: {
      flexGrow: 1,
      marginBottom: 18,
    },
    newsContainer: {
      flexGrow: 1,
      flexBasis: '100%',
    },
  }));

  const handleLayout = React.useCallback((event: LayoutChangeEvent) => {
    if (event.nativeEvent.layout.width < 500) {
      setSlidesPerView(1);
    } else {
      setSlidesPerView(2);
    }
  }, []);

  return (
    <LoadableContent testID='mobile-news-carousel-loadable-content-id' loading={!news}>
      <View testID='mobile-news-carousel-container-id' style={styles.container} onLayout={handleLayout}>
        {/* Array of news should be filled first, slides won't be displayed otherwise */}
        {news && (
          <Swiper testID='news-carousel-mobile-swiper-id' slidesPerView={slidesPerView}>
            {news.map((newsItem) => (
              <View
                testID={`news-carousel-mobile-item-${newsItem.id}`}
                style={styles.newsCardContainer}
                key={newsItem.id}>
                <NewsCard news={newsItem} style={styles.newsCard} containerStyles={styles.newsContainer} />
              </View>
            ))}
          </Swiper>
        )}
      </View>
    </LoadableContent>
  );
};
